/* tslint:disable */
/* eslint-disable */
/**
 * Charts Calculation API
 * API that provides an interface to make calculations on CDF Data
 *
 * The version of the OpenAPI document: 4.1.0-alpha.8-internal
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const AccuracyDimensionOperationsInnerNameEnum = {
    DetrendedUncertainty: 'detrended_uncertainty'
};
export const AccuracyDimensionResultOperationsInnerNameEnum = {
    DetrendedUncertainty: 'detrended_uncertainty'
};
export const CalculationResultQueryAggregateEnum = {
    Average: 'average',
    Max: 'max',
    Min: 'min',
    Count: 'count',
    Sum: 'sum'
};
export const CompletenessDimensionOperationsInnerNameEnum = {
    GapIdentification: 'gap_identification',
    LowDensityIdentification: 'low_density_identification'
};
export const CompletenessDimensionResultOperationsInnerNameEnum = {
    GapIdentification: 'gap_identification',
    LowDensityIdentification: 'low_density_identification'
};
export const InstanceIdTimeSeriesInputTypeEnum = {
    Ts: 'ts'
};
export const NumberConstInputTypeEnum = {
    Const: 'const'
};
export const OperationVersionInputsInnerTypesEnum = {
    Ts: 'ts',
    Const: 'const'
};
export const OperationVersionOutputsInnerTypesEnum = {
    Ts: 'ts',
    Const: 'const'
};
export const OperationVersionParamsTypeEnum = {
    Str: 'str',
    Int: 'int',
    Float: 'float',
    Bool: 'bool',
    Timestamp: 'timestamp',
    Timedelta: 'timedelta',
    ArrayStr: 'array_str',
    ArrayInt: 'array_int',
    ArrayFloat: 'array_float',
    ArrayBool: 'array_bool',
    ArrayTimestamp: 'array_timestamp',
    ArrayTimedelta: 'array_timedelta'
};
export const ResultInputTypeEnum = {
    Result: 'result'
};
export const StatusStatusEnum = {
    Running: 'Running',
    Pending: 'Pending',
    Success: 'Success',
    Failed: 'Failed',
    Error: 'Error',
    Cancelled: 'Cancelled',
    Unknown: 'Unknown'
};
export const StringConstInputTypeEnum = {
    Const: 'const'
};
export const TimeSeriesInputTypeEnum = {
    Ts: 'ts'
};
export const ValidityDimensionOperationsInnerNameEnum = {
    Drift: 'drift'
};
export const ValidityDimensionResultOperationsInnerNameEnum = {
    Drift: 'drift'
};
/**
 * CalculationsApi - axios parameter creator
 * @export
 */
export const CalculationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a calculation
         * @param {string} projectName Name of the project in CDF
         * @param {Calculation} [calculation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculation: (projectName_1, calculation_1, ...args_1) => __awaiter(this, [projectName_1, calculation_1, ...args_1], void 0, function* (projectName, calculation, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createGraphCalculation', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/calculations`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calculation, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a result query of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {CalculationResultQuery} [calculationResultQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculationResultQuery: (projectName_1, calculationId_1, calculationResultQuery_1, ...args_1) => __awaiter(this, [projectName_1, calculationId_1, calculationResultQuery_1, ...args_1], void 0, function* (projectName, calculationId, calculationResultQuery, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createGraphCalculationResultQuery', 'projectName', projectName);
            // verify required parameter 'calculationId' is not null or undefined
            assertParamExists('createGraphCalculationResultQuery', 'calculationId', calculationId);
            const localVarPath = `/projects/{project_name}/calculation-backend/calculations/{calculation_id}/result_query`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"calculation_id"}}`, encodeURIComponent(String(calculationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calculationResultQuery, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get result of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationResult: (projectName_1, calculationId_1, ...args_1) => __awaiter(this, [projectName_1, calculationId_1, ...args_1], void 0, function* (projectName, calculationId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getGraphCalculationResult', 'projectName', projectName);
            // verify required parameter 'calculationId' is not null or undefined
            assertParamExists('getGraphCalculationResult', 'calculationId', calculationId);
            const localVarPath = `/projects/{project_name}/calculation-backend/calculations/{calculation_id}/result`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"calculation_id"}}`, encodeURIComponent(String(calculationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get status of running calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationStatus: (projectName_1, calculationId_1, ...args_1) => __awaiter(this, [projectName_1, calculationId_1, ...args_1], void 0, function* (projectName, calculationId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getGraphCalculationStatus', 'projectName', projectName);
            // verify required parameter 'calculationId' is not null or undefined
            assertParamExists('getGraphCalculationStatus', 'calculationId', calculationId);
            const localVarPath = `/projects/{project_name}/calculation-backend/calculations/{calculation_id}`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"calculation_id"}}`, encodeURIComponent(String(calculationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CalculationsApi - functional programming interface
 * @export
 */
export const CalculationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CalculationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a calculation
         * @param {string} projectName Name of the project in CDF
         * @param {Calculation} [calculation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculation(projectName, calculation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGraphCalculation(projectName, calculation, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CalculationsApi.createGraphCalculation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a result query of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {CalculationResultQuery} [calculationResultQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CalculationsApi.createGraphCalculationResultQuery']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get result of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationResult(projectName, calculationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGraphCalculationResult(projectName, calculationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CalculationsApi.getGraphCalculationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get status of running calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationStatus(projectName, calculationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGraphCalculationStatus(projectName, calculationId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CalculationsApi.getGraphCalculationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CalculationsApi - factory interface
 * @export
 */
export const CalculationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CalculationsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a calculation
         * @param {string} projectName Name of the project in CDF
         * @param {Calculation} [calculation]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculation(projectName, calculation, options) {
            return localVarFp.createGraphCalculation(projectName, calculation, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a result query of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {CalculationResultQuery} [calculationResultQuery]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options) {
            return localVarFp.createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get result of the requested calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationResult(projectName, calculationId, options) {
            return localVarFp.getGraphCalculationResult(projectName, calculationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get status of running calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} calculationId UUID v4 of the requested calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphCalculationStatus(projectName, calculationId, options) {
            return localVarFp.getGraphCalculationStatus(projectName, calculationId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CalculationsApi - object-oriented interface
 * @export
 * @class CalculationsApi
 * @extends {BaseAPI}
 */
export class CalculationsApi extends BaseAPI {
    /**
     *
     * @summary Create a calculation
     * @param {string} projectName Name of the project in CDF
     * @param {Calculation} [calculation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    createGraphCalculation(projectName, calculation, options) {
        return CalculationsApiFp(this.configuration).createGraphCalculation(projectName, calculation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a result query of the requested calulation
     * @param {string} projectName Name of the project in CDF
     * @param {string} calculationId UUID v4 of the requested calculation
     * @param {CalculationResultQuery} [calculationResultQuery]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options) {
        return CalculationsApiFp(this.configuration).createGraphCalculationResultQuery(projectName, calculationId, calculationResultQuery, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get result of the requested calulation
     * @param {string} projectName Name of the project in CDF
     * @param {string} calculationId UUID v4 of the requested calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    getGraphCalculationResult(projectName, calculationId, options) {
        return CalculationsApiFp(this.configuration).getGraphCalculationResult(projectName, calculationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get status of running calculation
     * @param {string} projectName Name of the project in CDF
     * @param {string} calculationId UUID v4 of the requested calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationsApi
     */
    getGraphCalculationStatus(projectName, calculationId, options) {
        return CalculationsApiFp(this.configuration).getGraphCalculationStatus(projectName, calculationId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataProfilingApi - axios parameter creator
 * @export
 */
export const DataProfilingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create data profiling for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateDataProfilingParams} [createDataProfilingParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataProfilingCalculation: (projectName_1, createDataProfilingParams_1, ...args_1) => __awaiter(this, [projectName_1, createDataProfilingParams_1, ...args_1], void 0, function* (projectName, createDataProfilingParams, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createDataProfilingCalculation', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_profiling`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createDataProfilingParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get result of the requested data profiling calculations
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationResult: (projectName_1, dataProfilingId_1, ...args_1) => __awaiter(this, [projectName_1, dataProfilingId_1, ...args_1], void 0, function* (projectName, dataProfilingId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getDataProfilingCalculationResult', 'projectName', projectName);
            // verify required parameter 'dataProfilingId' is not null or undefined
            assertParamExists('getDataProfilingCalculationResult', 'dataProfilingId', dataProfilingId);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_profiling/{data_profiling_id}/result`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"data_profiling_id"}}`, encodeURIComponent(String(dataProfilingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get data profiling status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationStatus: (projectName_1, dataProfilingId_1, ...args_1) => __awaiter(this, [projectName_1, dataProfilingId_1, ...args_1], void 0, function* (projectName, dataProfilingId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getDataProfilingCalculationStatus', 'projectName', projectName);
            // verify required parameter 'dataProfilingId' is not null or undefined
            assertParamExists('getDataProfilingCalculationStatus', 'dataProfilingId', dataProfilingId);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_profiling/{data_profiling_id}`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"data_profiling_id"}}`, encodeURIComponent(String(dataProfilingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DataProfilingApi - functional programming interface
 * @export
 */
export const DataProfilingApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataProfilingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create data profiling for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateDataProfilingParams} [createDataProfilingParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataProfilingCalculation(projectName, createDataProfilingParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDataProfilingCalculation(projectName, createDataProfilingParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataProfilingApi.createDataProfilingCalculation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get result of the requested data profiling calculations
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationResult(projectName, dataProfilingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDataProfilingCalculationResult(projectName, dataProfilingId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataProfilingApi.getDataProfilingCalculationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get data profiling status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationStatus(projectName, dataProfilingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDataProfilingCalculationStatus(projectName, dataProfilingId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataProfilingApi.getDataProfilingCalculationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DataProfilingApi - factory interface
 * @export
 */
export const DataProfilingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataProfilingApiFp(configuration);
    return {
        /**
         *
         * @summary Create data profiling for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateDataProfilingParams} [createDataProfilingParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataProfilingCalculation(projectName, createDataProfilingParams, options) {
            return localVarFp.createDataProfilingCalculation(projectName, createDataProfilingParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get result of the requested data profiling calculations
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationResult(projectName, dataProfilingId, options) {
            return localVarFp.getDataProfilingCalculationResult(projectName, dataProfilingId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get data profiling status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataProfilingCalculationStatus(projectName, dataProfilingId, options) {
            return localVarFp.getDataProfilingCalculationStatus(projectName, dataProfilingId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataProfilingApi - object-oriented interface
 * @export
 * @class DataProfilingApi
 * @extends {BaseAPI}
 */
export class DataProfilingApi extends BaseAPI {
    /**
     *
     * @summary Create data profiling for a given tag or calculation
     * @param {string} projectName Name of the project in CDF
     * @param {CreateDataProfilingParams} [createDataProfilingParams]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataProfilingApi
     */
    createDataProfilingCalculation(projectName, createDataProfilingParams, options) {
        return DataProfilingApiFp(this.configuration).createDataProfilingCalculation(projectName, createDataProfilingParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get result of the requested data profiling calculations
     * @param {string} projectName Name of the project in CDF
     * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataProfilingApi
     */
    getDataProfilingCalculationResult(projectName, dataProfilingId, options) {
        return DataProfilingApiFp(this.configuration).getDataProfilingCalculationResult(projectName, dataProfilingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get data profiling status for a given id
     * @param {string} projectName Name of the project in CDF
     * @param {string} dataProfilingId UUID v4 of the requested data quality calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataProfilingApi
     */
    getDataProfilingCalculationStatus(projectName, dataProfilingId, options) {
        return DataProfilingApiFp(this.configuration).getDataProfilingCalculationStatus(projectName, dataProfilingId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DataQualityApi - axios parameter creator
 * @export
 */
export const DataQualityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a data quality calculation
         * @summary Create a data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {DataQuality} [dataQuality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataQualityCalculation: (projectName_1, dataQuality_1, ...args_1) => __awaiter(this, [projectName_1, dataQuality_1, ...args_1], void 0, function* (projectName, dataQuality, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createDataQualityCalculation', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_quality`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dataQuality, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get result of the requested data quality calulation
         * @summary Get result of the requested data quality calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationResult: (projectName_1, dataQualityId_1, ...args_1) => __awaiter(this, [projectName_1, dataQualityId_1, ...args_1], void 0, function* (projectName, dataQualityId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getDataQualityCalculationResult', 'projectName', projectName);
            // verify required parameter 'dataQualityId' is not null or undefined
            assertParamExists('getDataQualityCalculationResult', 'dataQualityId', dataQualityId);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_quality/{data_quality_id}/result`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"data_quality_id"}}`, encodeURIComponent(String(dataQualityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get status of running data quality calculation
         * @summary Get status of running data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationStatus: (projectName_1, dataQualityId_1, ...args_1) => __awaiter(this, [projectName_1, dataQualityId_1, ...args_1], void 0, function* (projectName, dataQualityId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getDataQualityCalculationStatus', 'projectName', projectName);
            // verify required parameter 'dataQualityId' is not null or undefined
            assertParamExists('getDataQualityCalculationStatus', 'dataQualityId', dataQualityId);
            const localVarPath = `/projects/{project_name}/calculation-backend/data_quality/{data_quality_id}`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"data_quality_id"}}`, encodeURIComponent(String(dataQualityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DataQualityApi - functional programming interface
 * @export
 */
export const DataQualityApiFp = function (configuration) {
    const localVarAxiosParamCreator = DataQualityApiAxiosParamCreator(configuration);
    return {
        /**
         * Create a data quality calculation
         * @summary Create a data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {DataQuality} [dataQuality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataQualityCalculation(projectName, dataQuality, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDataQualityCalculation(projectName, dataQuality, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataQualityApi.createDataQualityCalculation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get result of the requested data quality calulation
         * @summary Get result of the requested data quality calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationResult(projectName, dataQualityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDataQualityCalculationResult(projectName, dataQualityId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataQualityApi.getDataQualityCalculationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get status of running data quality calculation
         * @summary Get status of running data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationStatus(projectName, dataQualityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDataQualityCalculationStatus(projectName, dataQualityId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DataQualityApi.getDataQualityCalculationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DataQualityApi - factory interface
 * @export
 */
export const DataQualityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DataQualityApiFp(configuration);
    return {
        /**
         * Create a data quality calculation
         * @summary Create a data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {DataQuality} [dataQuality]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDataQualityCalculation(projectName, dataQuality, options) {
            return localVarFp.createDataQualityCalculation(projectName, dataQuality, options).then((request) => request(axios, basePath));
        },
        /**
         * Get result of the requested data quality calulation
         * @summary Get result of the requested data quality calulation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationResult(projectName, dataQualityId, options) {
            return localVarFp.getDataQualityCalculationResult(projectName, dataQualityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get status of running data quality calculation
         * @summary Get status of running data quality calculation
         * @param {string} projectName Name of the project in CDF
         * @param {string} dataQualityId UUID v4 of the requested data quality calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataQualityCalculationStatus(projectName, dataQualityId, options) {
            return localVarFp.getDataQualityCalculationStatus(projectName, dataQualityId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DataQualityApi - object-oriented interface
 * @export
 * @class DataQualityApi
 * @extends {BaseAPI}
 */
export class DataQualityApi extends BaseAPI {
    /**
     * Create a data quality calculation
     * @summary Create a data quality calculation
     * @param {string} projectName Name of the project in CDF
     * @param {DataQuality} [dataQuality]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataQualityApi
     */
    createDataQualityCalculation(projectName, dataQuality, options) {
        return DataQualityApiFp(this.configuration).createDataQualityCalculation(projectName, dataQuality, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get result of the requested data quality calulation
     * @summary Get result of the requested data quality calulation
     * @param {string} projectName Name of the project in CDF
     * @param {string} dataQualityId UUID v4 of the requested data quality calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataQualityApi
     */
    getDataQualityCalculationResult(projectName, dataQualityId, options) {
        return DataQualityApiFp(this.configuration).getDataQualityCalculationResult(projectName, dataQualityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get status of running data quality calculation
     * @summary Get status of running data quality calculation
     * @param {string} projectName Name of the project in CDF
     * @param {string} dataQualityId UUID v4 of the requested data quality calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataQualityApi
     */
    getDataQualityCalculationStatus(projectName, dataQualityId, options) {
        return DataQualityApiFp(this.configuration).getDataQualityCalculationStatus(projectName, dataQualityId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OperationsApi - axios parameter creator
 * @export
 */
export const OperationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary List of available operations
         * @param {string} projectName Name of the project in CDF
         * @param {boolean} [includeDeprecated] Flag if deprecated functions should be included. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperations: (projectName_1, includeDeprecated_1, ...args_1) => __awaiter(this, [projectName_1, includeDeprecated_1, ...args_1], void 0, function* (projectName, includeDeprecated, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getOperations', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/operations`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (includeDeprecated !== undefined) {
                localVarQueryParameter['include_deprecated'] = includeDeprecated;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OperationsApi - functional programming interface
 * @export
 */
export const OperationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OperationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary List of available operations
         * @param {string} projectName Name of the project in CDF
         * @param {boolean} [includeDeprecated] Flag if deprecated functions should be included. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperations(projectName, includeDeprecated, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOperations(projectName, includeDeprecated, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['OperationsApi.getOperations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * OperationsApi - factory interface
 * @export
 */
export const OperationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OperationsApiFp(configuration);
    return {
        /**
         *
         * @summary List of available operations
         * @param {string} projectName Name of the project in CDF
         * @param {boolean} [includeDeprecated] Flag if deprecated functions should be included. Defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperations(projectName, includeDeprecated, options) {
            return localVarFp.getOperations(projectName, includeDeprecated, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OperationsApi - object-oriented interface
 * @export
 * @class OperationsApi
 * @extends {BaseAPI}
 */
export class OperationsApi extends BaseAPI {
    /**
     *
     * @summary List of available operations
     * @param {string} projectName Name of the project in CDF
     * @param {boolean} [includeDeprecated] Flag if deprecated functions should be included. Defaults to true.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationsApi
     */
    getOperations(projectName, includeDeprecated, options) {
        return OperationsApiFp(this.configuration).getOperations(projectName, includeDeprecated, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create statistics for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateStatisticsParams} [createStatisticsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatisticsCalculation: (projectName_1, createStatisticsParams_1, ...args_1) => __awaiter(this, [projectName_1, createStatisticsParams_1, ...args_1], void 0, function* (projectName, createStatisticsParams, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createStatisticsCalculation', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/statistics`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createStatisticsParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get result of the requested statistics
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationResult: (projectName_1, statisticsId_1, ...args_1) => __awaiter(this, [projectName_1, statisticsId_1, ...args_1], void 0, function* (projectName, statisticsId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getStatisticsCalculationResult', 'projectName', projectName);
            // verify required parameter 'statisticsId' is not null or undefined
            assertParamExists('getStatisticsCalculationResult', 'statisticsId', statisticsId);
            const localVarPath = `/projects/{project_name}/calculation-backend/statistics/{statistics_id}/result`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"statistics_id"}}`, encodeURIComponent(String(statisticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get statistics status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationStatus: (projectName_1, statisticsId_1, ...args_1) => __awaiter(this, [projectName_1, statisticsId_1, ...args_1], void 0, function* (projectName, statisticsId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getStatisticsCalculationStatus', 'projectName', projectName);
            // verify required parameter 'statisticsId' is not null or undefined
            assertParamExists('getStatisticsCalculationStatus', 'statisticsId', statisticsId);
            const localVarPath = `/projects/{project_name}/calculation-backend/statistics/{statistics_id}`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"statistics_id"}}`, encodeURIComponent(String(statisticsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create statistics for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateStatisticsParams} [createStatisticsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatisticsCalculation(projectName, createStatisticsParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStatisticsCalculation(projectName, createStatisticsParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StatisticsApi.createStatisticsCalculation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get result of the requested statistics
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationResult(projectName, statisticsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatisticsCalculationResult(projectName, statisticsId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StatisticsApi.getStatisticsCalculationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get statistics status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationStatus(projectName, statisticsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatisticsCalculationStatus(projectName, statisticsId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['StatisticsApi.getStatisticsCalculationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = StatisticsApiFp(configuration);
    return {
        /**
         *
         * @summary Create statistics for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateStatisticsParams} [createStatisticsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStatisticsCalculation(projectName, createStatisticsParams, options) {
            return localVarFp.createStatisticsCalculation(projectName, createStatisticsParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get result of the requested statistics
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationResult(projectName, statisticsId, options) {
            return localVarFp.getStatisticsCalculationResult(projectName, statisticsId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get statistics status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} statisticsId UUID v4 of the requested statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsCalculationStatus(projectName, statisticsId, options) {
            return localVarFp.getStatisticsCalculationStatus(projectName, statisticsId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     *
     * @summary Create statistics for a given tag or calculation
     * @param {string} projectName Name of the project in CDF
     * @param {CreateStatisticsParams} [createStatisticsParams]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    createStatisticsCalculation(projectName, createStatisticsParams, options) {
        return StatisticsApiFp(this.configuration).createStatisticsCalculation(projectName, createStatisticsParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get result of the requested statistics
     * @param {string} projectName Name of the project in CDF
     * @param {string} statisticsId UUID v4 of the requested statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    getStatisticsCalculationResult(projectName, statisticsId, options) {
        return StatisticsApiFp(this.configuration).getStatisticsCalculationResult(projectName, statisticsId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get statistics status for a given id
     * @param {string} projectName Name of the project in CDF
     * @param {string} statisticsId UUID v4 of the requested statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    getStatisticsCalculationStatus(projectName, statisticsId, options) {
        return StatisticsApiFp(this.configuration).getStatisticsCalculationStatus(projectName, statisticsId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ThresholdsApi - axios parameter creator
 * @export
 */
export const ThresholdsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Compute thresholds for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateThresholdsParams} [createThresholdsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThresholdCalculation: (projectName_1, createThresholdsParams_1, ...args_1) => __awaiter(this, [projectName_1, createThresholdsParams_1, ...args_1], void 0, function* (projectName, createThresholdsParams, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('createThresholdCalculation', 'projectName', projectName);
            const localVarPath = `/projects/{project_name}/calculation-backend/thresholds`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createThresholdsParams, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get result of the requested threshold computation
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationResult: (projectName_1, thresholdId_1, ...args_1) => __awaiter(this, [projectName_1, thresholdId_1, ...args_1], void 0, function* (projectName, thresholdId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getThresholdCalculationResult', 'projectName', projectName);
            // verify required parameter 'thresholdId' is not null or undefined
            assertParamExists('getThresholdCalculationResult', 'thresholdId', thresholdId);
            const localVarPath = `/projects/{project_name}/calculation-backend/thresholds/{threshold_id}/result`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"threshold_id"}}`, encodeURIComponent(String(thresholdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get threshold computation status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationStatus: (projectName_1, thresholdId_1, ...args_1) => __awaiter(this, [projectName_1, thresholdId_1, ...args_1], void 0, function* (projectName, thresholdId, options = {}) {
            // verify required parameter 'projectName' is not null or undefined
            assertParamExists('getThresholdCalculationStatus', 'projectName', projectName);
            // verify required parameter 'thresholdId' is not null or undefined
            assertParamExists('getThresholdCalculationStatus', 'thresholdId', thresholdId);
            const localVarPath = `/projects/{project_name}/calculation-backend/thresholds/{threshold_id}`
                .replace(`{${"project_name"}}`, encodeURIComponent(String(projectName)))
                .replace(`{${"threshold_id"}}`, encodeURIComponent(String(thresholdId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication AuthTicket required
            yield setApiKeyToObject(localVarHeaderParameter, "auth-ticket", configuration);
            // authentication BearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ThresholdsApi - functional programming interface
 * @export
 */
export const ThresholdsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ThresholdsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Compute thresholds for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateThresholdsParams} [createThresholdsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThresholdCalculation(projectName, createThresholdsParams, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createThresholdCalculation(projectName, createThresholdsParams, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ThresholdsApi.createThresholdCalculation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get result of the requested threshold computation
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationResult(projectName, thresholdId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThresholdCalculationResult(projectName, thresholdId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ThresholdsApi.getThresholdCalculationResult']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get threshold computation status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationStatus(projectName, thresholdId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThresholdCalculationStatus(projectName, thresholdId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ThresholdsApi.getThresholdCalculationStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ThresholdsApi - factory interface
 * @export
 */
export const ThresholdsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ThresholdsApiFp(configuration);
    return {
        /**
         *
         * @summary Compute thresholds for a given tag or calculation
         * @param {string} projectName Name of the project in CDF
         * @param {CreateThresholdsParams} [createThresholdsParams]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createThresholdCalculation(projectName, createThresholdsParams, options) {
            return localVarFp.createThresholdCalculation(projectName, createThresholdsParams, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get result of the requested threshold computation
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationResult(projectName, thresholdId, options) {
            return localVarFp.getThresholdCalculationResult(projectName, thresholdId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get threshold computation status for a given id
         * @param {string} projectName Name of the project in CDF
         * @param {string} thresholdId UUID v4 of the requested treshold calculation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThresholdCalculationStatus(projectName, thresholdId, options) {
            return localVarFp.getThresholdCalculationStatus(projectName, thresholdId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ThresholdsApi - object-oriented interface
 * @export
 * @class ThresholdsApi
 * @extends {BaseAPI}
 */
export class ThresholdsApi extends BaseAPI {
    /**
     *
     * @summary Compute thresholds for a given tag or calculation
     * @param {string} projectName Name of the project in CDF
     * @param {CreateThresholdsParams} [createThresholdsParams]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    createThresholdCalculation(projectName, createThresholdsParams, options) {
        return ThresholdsApiFp(this.configuration).createThresholdCalculation(projectName, createThresholdsParams, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get result of the requested threshold computation
     * @param {string} projectName Name of the project in CDF
     * @param {string} thresholdId UUID v4 of the requested treshold calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    getThresholdCalculationResult(projectName, thresholdId, options) {
        return ThresholdsApiFp(this.configuration).getThresholdCalculationResult(projectName, thresholdId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get threshold computation status for a given id
     * @param {string} projectName Name of the project in CDF
     * @param {string} thresholdId UUID v4 of the requested treshold calculation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdsApi
     */
    getThresholdCalculationStatus(projectName, thresholdId, options) {
        return ThresholdsApiFp(this.configuration).getThresholdCalculationStatus(projectName, thresholdId, options).then((request) => request(this.axios, this.basePath));
    }
}
